import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Button } from "./ui/button";
import { toast } from "sonner";
import { Trash2, RefreshCw } from "lucide-react";

export default function Favorites({ onUsePhrase }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/favorites");
      setItems(data);
    } catch {
      toast.error("Could not load favorites");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const remove = async (id) => {
    try {
      await api.delete(`/favorites/${id}`);
      setItems((p) => p.filter((x) => x.id !== id));
      toast.success("Removed");
    } catch {
      toast.error("Could not delete");
    }
  };

  return (
    <div data-testid="favorites-pane">
      <div className="flex items-center justify-between mb-3">
        <p className="text-sm uppercase tracking-[0.2em] text-zinc-500">Saved phrases</p>
        <Button variant="ghost" size="sm" onClick={load} data-testid="favorites-refresh-button">
          <RefreshCw className="w-4 h-4" />
        </Button>
      </div>
      {loading ? (
        <p className="text-sm text-zinc-500">Loading…</p>
      ) : items.length === 0 ? (
        <p className="text-sm text-zinc-500" data-testid="favorites-empty">No favorites yet. Star a translation to save it for quick reuse.</p>
      ) : (
        <div className="space-y-2">
          {items.map((f) => (
            <div key={f.id} className="border border-zinc-200 rounded-lg p-3 bg-white" data-testid={`favorite-item-${f.id}`}>
              <div className="flex items-start justify-between gap-2">
                <div className="min-w-0 flex-1">
                  <p className="text-xs text-zinc-500 mb-1">
                    {f.source_lang} → {f.target_lang}
                  </p>
                  <button
                    onClick={() => onUsePhrase?.(f.text)}
                    className="text-left text-sm text-zinc-800 hover:underline block w-full"
                    data-testid={`favorite-use-${f.id}`}
                  >
                    {f.text}
                  </button>
                  {f.translation && (
                    <p className="text-sm text-zinc-600 mt-1 italic">{f.translation}</p>
                  )}
                </div>
                <button
                  onClick={() => remove(f.id)}
                  className="p-2 text-zinc-400 hover:text-red-600 transition-colors"
                  data-testid={`favorite-delete-${f.id}`}
                >
                  <Trash2 className="w-4 h-4" />
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
